var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-grid"},_vm._l((_vm.photos),function(photo){return _c('div',{key:photo.id,staticClass:"position-relative fake-link",on:{"click":function($event){return _vm.$store.commit('photo/setEditPhoto', photo)}}},[_c('onboarding-photo-item',{attrs:{"photo":photo}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }